export * from './hms.service';



// WEBPACK FOOTER //
// /ng-app/src/shared/index.ts